
import request from '../request'

/**
 * 查看简历纠错数据
 * cv_token 或单独模块
 * type cv edus works orgs custom_section_infos skill...
 */
 export const getCvErrors = (data) => {
	return request({
		url: `/v3/cv_errors`,
		method: 'POST',
		data
	})
}
/**
 * 简历纠错
 * cv_token 或单独模块
 * type cv edus works orgs custom_section_infos skill...
 */
 export const findCvErrors = (data) => {
	return request({
		url: `/v3/find_errors`,
		method: 'POST',
		data
	})
}
/**
 * 简历纠错更正
 * cv_token 或单独模块
 */
 export const putCvErrors = (data) => {
	return request({
		url: `/v3/find_errors`,
		method: 'PUT',
		data
	})
}